const serialize = (path: string, params: any = {}) => {
  Object.keys(params).forEach((key) => {
    path = path.replace(`:${key}`, encodeURIComponent(params[key]));
  });
  return path;
};

export default serialize;
